// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--1gTdF","triangle":"styles-module--triangle--QdZ2H"};